
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";

export default function DocumentViewer({ docobj }) {
  let sFileType = "image/jpeg";
  if (docobj.fileType == ".docx") sFileType = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
  if (docobj.fileType == ".doc") sFileType = "application/msword";
  if (docobj.fileType == ".bmp") sFileType = "image/bmp";
  if (docobj.fileType == ".csv") sFileType = "text/csv";
  if (docobj.fileType == ".odt") sFileType = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
  if (docobj.fileType == ".gif") sFileType = "image/gif";
  if (docobj.fileType == ".jpg") sFileType = "image/jpg";
  if (docobj.fileType == ".pdf") sFileType = "application/pdf";
  if (docobj.fileType == ".png") sFileType = "image/png";
  if (docobj.fileType == ".ppt") sFileType = "application/vnd.ms-powerpoint";
  if (docobj.fileType == ".pptx") sFileType = "application/vnd.openxmlformats-officedocument.presentationml.presentation";
  if (docobj.fileType == ".tiff") sFileType = "image/tiff";
  if (docobj.fileType == ".txt") sFileType = "text/plain";
  if (docobj.fileType == ".xls") sFileType = "application/vnd.ms-excel";
  if (docobj.fileType == ".xlsx") sFileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

  const docs = [
    {
      uri: docobj.uri,
      fileType: sFileType,
      fileName: docobj.fileName,
    },
  ];

  return (
    <div
      style={{
        height: "70vh", // or "80vh"
        width: "100%",  // adjust if you want a max width
        display: "flex",
        alignItems: "center",
        justifyContent: "center", // Center vertically/horizontally if you want
      }}
    >
      <DocViewer
        pluginRenderers={DocViewerRenderers}
        documents={docs}
        config={{
          header: {
            disableHeader: false,
            disableFileName: true,
            retainURLParams: false,
          },
        }}
        style={{ height: "100%", width: "100%" }}
      />
    </div>
  );
}



// import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";


// export default function DocumentViewer({docobj}) {

//     let sFileType = "image/jpeg";
//     if(docobj.fileType == ".docx") sFileType = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
//     if(docobj.fileType == ".doc") sFileType = "application/msword";
//     if(docobj.fileType == ".bmp") sFileType = "image/bmp";
//     if(docobj.fileType == ".csv") sFileType = "text/csv";
//     if(docobj.fileType == ".odt") sFileType = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
//     if(docobj.fileType == ".gif") sFileType = "image/gif";
//     if(docobj.fileType == ".jpg") sFileType = "image/jpg";
//     if(docobj.fileType == ".pdf") sFileType = "application/pdf";
//     if(docobj.fileType == ".png") sFileType = "image/png";
//     if(docobj.fileType == ".ppt") sFileType = "application/vnd.ms-powerpoint";
//     if(docobj.fileType == ".pptx") sFileType = "applicatiapplication/vnd.openxmlformats-officedocument.presentationml.presentation";
//     if(docobj.fileType == ".tiff") sFileType = "image/tiff";
//     if(docobj.fileType == ".txt") sFileType = "text/plain";
//     if(docobj.fileType == ".xls") sFileType = "application/vnd.ms-excel";
//     if(docobj.fileType == ".xlsx") sFileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";


//     const docs = [{
//         uri : docobj.uri, //"https://hmcareplannerstorage.blob.core.windows.net/t1clientdocsc1010201183240/double_room_1.jpeg",
//         fileType : sFileType, //"image/jpeg",
//         fileName : docobj.fileName
//         },];
        
//   return (
//     <>     
//       <DocViewer
//         pluginRenderers={DocViewerRenderers}        
//         documents={docs}
//         config={{
//           header: {
//             disableHeader: false,
//             disableFileName: true,
//             retainURLParams: false            
//           }
//         }}                
//         style={{ height: "100%" }}
//       />
//     </>
//   )

// }

// // export default DocumentViewer


